import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { Link, useLocation } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function ProspectTabEditButton() {
    const { t } = usePolTranslation();
    const { pathname } = useLocation();

    return (
        <>
            <Link to={`${pathname}/edit`}
                  className="prospect-tab__prospect__header__action"
                  data-for="link-edit"
                  data-tip={t('edit')}>
                <PolIcon icon='edit'/>
            </Link>
            <ReactTooltip id="link-edit" effect="solid"/>
        </>
    )
}
